import React from "react";
import { Row } from "react-bootstrap";
import { AdsPlanCard } from "../impl/screens/components/ads-plan-card.component.tsx";
import { AdsPlanStatementPlans } from "../interfaces/index.js";

export const AdsPlans: React.FC<AdsPlanStatementPlans> = ({ plans, signedPlan, handlerShowModalPayment }) => {
    return (
        <Row style={{ overflow: "hidden" }} className={"font-poppins my-5"}>
            {
                plans.map((plan) => {
                    return (<AdsPlanCard plan={plan} key={plan.id} signedPlan={signedPlan} handlerShowModalPayment={handlerShowModalPayment} />)
                })
            }
        </Row >
    );
}
